import { ReduxState } from 'app/redux/types';

import { selectClientInfoData } from './state';

export const selectPermissions = (state: ReduxState) => (
  selectClientInfoData(state)?.permissions
);

export const hasAccessToStakesBookmaker = (state: ReduxState) => (
  selectPermissions(state)?.includes('StakesBookmaker') ?? true
);

export const hasAccessToStakesExternalGames = (state: ReduxState) => (
  selectPermissions(state)?.includes('StakesExternalGames') ?? true
);

export const hasAccessToStakesCashout = (state: ReduxState) => (
  selectPermissions(state)?.includes('StakesCashout') ?? true
);

export const hasAccessToPromoCodeActivation = (state: ReduxState) => (
  selectPermissions(state)?.includes('PromoCodeActivation') ?? true
);

